export enum ErrorType {
    CLIENT_ERROR = 'clientError',
    NOT_FOUND = 'notFound',
    OFFLINE = 'offline',
    PRODUCT_NOT_AVAILABLE_FOR_REGION = 'productNotAvailableForRegion',
    SERVER_ERROR = 'serverError'
}

export default ErrorType;
